/* global jQuery */
import $ from "jquery";
import slick from "slick-carousel";

class QuotesSlider {
    constructor() {
        this.$window = $(window);

        $('.js-quotes-slider').slick({
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true
        });
    }
}

export default QuotesSlider;
